import { chargesListTypes } from './actionTypes';

export const getChargesList = (payload: any) => ({
  type: chargesListTypes.GET_CHARGESLIST,
  payload,
});

export const getChargesListSuccess = (payload: any) => ({
  type: chargesListTypes.GET_CHARGESLIST_SUCCESS,
  payload,
});

export const getChargesListFail = (error: any) => ({
  type: chargesListTypes.GET_CHARGESLIST_FAIL,
  payload: error,
});

